/**
 * StockoutAiAnalysisModal
 * Resultados da análise IA de ruptura (padrão ReviewAnalysisPage).
 */

import React, { useState } from 'react'
import { X, WandSparkles, Loader2, BrainCircuit, ChevronDown, CheckCircle2 } from 'lucide-react'
import './StockoutAiAnalysisModal.css'

const URGENCY_LABELS = {
  critical: 'Crítico',
  high: 'Alto',
  normal: 'Normal',
  low: 'Baixo'
}

function StockoutAiAnalysisModal({
  isOpen,
  onClose,
  loading = false,
  analyses = [],
  onApply,
  applying = false
}) {
  const [openReasonId, setOpenReasonId] = useState(null)
  const [editedQty, setEditedQty] = useState({})

  if (!isOpen) return null

  const getQty = (item) => {
    const key = item.productId
    if (editedQty[key] !== undefined) return editedQty[key]
    return item.suggestedQty
  }

  const handleApply = () => {
    const payload = analyses.map((item) => ({
      productId: item.productId,
      suggestedQty: getQty(item),
      reason: item.reason
    }))
    onApply?.(payload)
  }

  return (
    <div className="stockout-ai-modal-overlay" onClick={onClose}>
      <div className="stockout-ai-modal" onClick={(e) => e.stopPropagation()}>
        <header className="stockout-ai-modal-header">
          <div className="stockout-ai-modal-header-left">
            <div className="stockout-ai-modal-icon">
              <WandSparkles size={22} />
            </div>
            <div>
              <h3>Análise IA — Ruptura de Estoque</h3>
              <p>Sugestões do Gemini com base em consumo e histórico</p>
            </div>
          </div>
          <button type="button" className="stockout-ai-modal-close" onClick={onClose} aria-label="Fechar">
            <X size={22} />
          </button>
        </header>

        <div className="stockout-ai-modal-body">
          {loading ? (
            <div className="stockout-ai-modal-loading">
              <Loader2 size={28} className="spinning" />
              <span>Processando dados de consumo com Gemini...</span>
            </div>
          ) : analyses.length === 0 ? (
            <p className="stockout-ai-modal-empty">Nenhuma análise disponível.</p>
          ) : (
            <div className="stockout-ai-modal-list">
              {analyses.map((item) => (
                <article key={item.productId} className="stockout-ai-item">
                  <div className="stockout-ai-item-main">
                    <div>
                      <strong>{item.name}</strong>
                      <span>{item.sku || '—'} · {item.brand || 'Sem marca'}</span>
                    </div>
                    <div className="stockout-ai-item-stats">
                      <span>Disp. {item.currentStock}</span>
                      <span>Mín. {item.minStock}</span>
                      <span className={`stockout-ai-urgency stockout-ai-urgency--${item.urgency}`}>
                        {URGENCY_LABELS[item.urgency] || item.urgency}
                      </span>
                    </div>
                  </div>

                  <div className="stockout-ai-item-qty-row">
                    <label>
                      Qtd. sugerida IA
                      <input
                        type="number"
                        min="0"
                        value={getQty(item)}
                        onChange={(e) => setEditedQty((prev) => ({
                          ...prev,
                          [item.productId]: Math.max(0, parseInt(e.target.value, 10) || 0)
                        }))}
                      />
                    </label>
                    <span className="stockout-ai-confidence">
                      Confiança {(Math.round((item.confidence || 0) * 100))}%
                    </span>
                  </div>

                  {item.reason && (
                    <div className="stockout-ai-reasoning">
                      <button
                        type="button"
                        className="stockout-ai-reasoning-toggle"
                        onClick={() => setOpenReasonId(
                          openReasonId === item.productId ? null : item.productId
                        )}
                      >
                        <BrainCircuit size={14} />
                        Ver raciocínio da IA
                        <ChevronDown
                          size={14}
                          className={openReasonId === item.productId ? 'is-open' : ''}
                        />
                      </button>
                      {openReasonId === item.productId && (
                        <div className="stockout-ai-reasoning-content">
                          <p>{item.reason}</p>
                        </div>
                      )}
                    </div>
                  )}
                </article>
              ))}
            </div>
          )}
        </div>

        {!loading && analyses.length > 0 && (
          <footer className="stockout-ai-modal-footer">
            <button type="button" className="stockout-ai-btn-secondary" onClick={onClose}>
              Fechar
            </button>
            <button
              type="button"
              className="stockout-ai-btn-primary"
              disabled={applying}
              onClick={handleApply}
            >
              {applying ? <Loader2 size={16} className="spinning" /> : <CheckCircle2 size={16} />}
              Usar quantidades IA nos rascunhos
            </button>
          </footer>
        )}
      </div>
    </div>
  )
}

export default StockoutAiAnalysisModal
